import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { AutomationWizardForm } from '../../containers'
import { Session } from '../../../../state/utils/session'

class AutomationCreatorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_AUTOMATIONS_PATH.replace(':client_id', this.state.session.getClientSession())}>
                        Automations
                    </NavLink>
                </li>
                <li>New Automation</li>
            </>
    )
  }

  render () {
    return (
            <>

                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={'New Automation'}
                        subTitle={'Create a new automation'}
                        paths={this.renderHeaderPaths}
                    />
                    <AutomationWizardForm/>
                </PageContainerLayout>
            </>
    )
  }
}

export { AutomationCreatorPage }
